import React from 'react';
import { Divider } from '@mui/material';
import { DonorWithWallet, GiftSummary } from '../../../../api';
import { assetUrl, webConfig } from '../../../../utils/webConfig';
import { amountNumberFormat } from '../../../../utils/functions';
import { DonorAvatar } from '../../../../components';

interface ProfileCardProps {
    profile: DonorWithWallet | undefined;
    gift: GiftSummary | undefined;
}

export const ProfileCard: React.FC<ProfileCardProps> = ({ profile, gift }) => {
    const avatarSrc = profile?.donor.pictureUrl
        ? profile.donor.pictureUrl.startsWith('data:')
            ? profile.donor.pictureUrl
            : assetUrl(profile.donor.pictureUrl)
        : webConfig.doneeAvatarDefault;

    return (
        <div
            data-testid="profile-card"
            className="relative rounded-[24px] shadow-high bg-white max-w-[335px] w-full flex flex-col items-center gap-6 pt-11"
        >
            <div
                data-testid="profile-avatar-wrapper"
                className="absolute top-0 left-[50%] translate-x-[-50%] translate-y-[-50%]"
            >
                <DonorAvatar
                    className="w-[64px] h-[64px] rounded-full"
                    src={avatarSrc}
                    title={profile?.donor.name}
                />
            </div>
            <div
                data-testid="profile-name"
                className="text-heading-medium text-primary"
            >
                {profile?.donor.name}
            </div>
            <div
                data-testid="profile-stats"
                className="flex w-full pb-5"
            >
                <div
                    data-testid="profile-gifts-count"
                    className="flex flex-col items-center flex-1"
                >
                    <div className="text-label-medium text-primary">
                        {gift?.all.count}
                    </div>
                    <div className="text-body-small text-secondary">Gifts</div>
                </div>
                <Divider
                    orientation="vertical"
                    flexItem
                />
                <div
                    data-testid="profile-total-giving"
                    className="flex flex-col items-center flex-1"
                >
                    <div className="text-label-medium text-primary">
                        {amountNumberFormat(gift?.all.total)}
                    </div>
                    <div className="text-body-small text-secondary">
                        Total Giving
                    </div>
                </div>
            </div>
        </div>
    );
};
